import './App.css';
import Nav from './Nav'
import BookADiscoveryCall from './BookADiscoveryCall'
import InsightTimer from './InsightTimer'
import LinkTree from './LinkTree'
import headShot from './assets/bioImage.jpg'
import yogaPose from './assets/yoga-pose.png'
import onions from './assets/onions.jpg'
import alternateNostril from './assets/alternate-nostril.png'

import { FaInstagram } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';


function App() {
  return (
    <>
    <Nav />

  <section id="hero" className="section">
    <div className='horizontal'>
    <div className='vertical'>
    <h1 className='chloe'>Chloe Chaput, CAS</h1>
    <h3>Clinical Ayurvedic Specialist,</h3>
    <h3>Yoga Instructor,</h3> 
    <h3> Reiki Practitioner,</h3>
    </div>
    <img src={headShot} className="headShot" alt="Chloe"></img>
    </div>
    <p>Ayurveda teaches us how to live in alignment with our unique nature and the rhythms of the world around us.</p>
    <p>Through individualized support, movement, breath, rest and simple daily practices, we create the conditions for greater balance, resilience and connection.</p>
    <BookADiscoveryCall />
    <InsightTimer />
  </section>
  <div className="image-block">
  <img src={yogaPose} className="yoga-pose" alt="Chloe"></img>
  </div>
  <section id="work-with-me" className="section">
  <h2>Offerings</h2>
  <div className="offering">
    <h3>Clinical Ayurveda</h3>
    <p>One-to-one Clinical Ayurvedic consultations and personalized treatment plans designed around your unique constitution, current patterns and individual goals.</p>
    <a href="#clinical-ayurveda" className="learn-more">Learn More</a>
  </div>
  <div className="offering">
    <h3>Yoga & Meditation</h3>
    <p>Weekly classes, Ayurveda Yoga workshops, private and small group yoga sessions.</p>
    <p>Free on demand meditations on Insight Timer.</p>
    <a href="#yoga-and-meditation" className="learn-more">Learn More</a>
  </div>

  <div className="offering">
    <h3>Reiki</h3>
    <p>Individual Reiki sessions offering intentional space for restoration, rejuvenation and energetic support.</p>
  </div>

  <BookADiscoveryCall />
  <InsightTimer />
</section>
<div className="image-block">
  <img src={alternateNostril} className="alternate-nostril" alt="Alternate Nostril"></img>
  </div>
  <section id="clinical-ayurveda" className="section">
    <h2>Clinical Ayurveda</h2>
    <p>Ayurvedic consultations provide an opportunity to better understand your unique constitution, current patterns and the factors influencing your health and wellbeing.</p>
    <p>Together, we develop a personalized treatment plan designed around your individual needs and goals.</p>
    <h3>Treatment plans may include:</h3>
    <p>Nutrition · Pranayama and breath practices · Body movement · Colour therapy · Sound therapy · Aromatherapy · Touch therapy, including self-oil massage and marma therapy · Yoga Nidra and non-sleep deep rest · Lifestyle and daily rhythm practices · Herbal support, when appropriate</p>
    <h3>Small, intentional changes can create the conditions for deeper healing over time.</h3>
    <h3>Not sure where to begin?</h3>
    <p>Schedule a free 15 minute session to discuss your goals, ask questions about working together and see if Clinical Ayurveda is right for you.</p>
    <BookADiscoveryCall />
  </section>

  <section id="yoga-and-meditation" className="section">
    <h2>Yoga & Meditation</h2>
    <p>I teach Yoga and Ayurveda through weekly classes, workshops and individualized sessions.</p>
    <p>My approach brings together movement, breath, rest and Ayurvedic wisdom to support the body through changing seasons and stages of life.</p>
    <h3>Weekly Classes</h3>
    <div className="horizontal">
    <h4>I currently teach at:</h4>
    <div className="yoga-studio">
    <a href="https://www.shiftyogacollective.com/" target="_blank" 
  rel="noopener noreferrer" className="studio">Shift Yoga - Guelph</a>
    <a href="https://www.yogainfergus.ca/" target="_blank" 
  rel="noopener noreferrer" className="studio">Yoga in Fergus - Fergus</a>
    <a href="https://www.sparkyogaelora.com/"  target="_blank" 
  rel="noopener noreferrer" className="studio">Spark Yoga - Elora</a>
    </div>
    </div>
    <h2>Ayurveda Yoga Workshop</h2>
    <p>From fall through spring, I offer monthly Ayurveda Yoga sessions at Yoga in Fergus.</p>
    <p>These classes explore the changing qualities of the seasons and how we can use movement, breath, rest and Ayurvedic practices to maintain or restore balance.</p>
    <h2>Private & Small Group Yoga</h2>
    <p>Private and small group yoga sessions offer a more personalized experience for individuals, friends, families or small groups.</p>
    <p>Sessions can be tailored to your individual or group's needs and may incorporate yoga, breathwork, meditation, Yoga Nidra and Ayurvedic principles.</p>
    <p>Whether you are looking for individualized support, a private practice or a shared experience with a small group, sessions can be created around your intentions and needs.</p>
    <h3>Email to Book a Private or Small Group Session</h3>  
    <BookADiscoveryCall />
    <h2>Meditation</h2>
    <p>I also share guided meditations and Yoga Nidra practices through Insight Timer.</p>
    <p>These free recordings offer an opportunity to bring some of the practices I teach into your own home and create moments of stillness, rest and connection in your everyday life.</p>
    <h3>Explore Free Meditations & Yoga Nidra on Insight Timer</h3>
    <InsightTimer />
  </section>
 
  <section id="about" className="section">
  <h2>About</h2>
  <div className="horizontal">
  <img src={onions} className="onions" alt="onions"/>
  <div>
  <p>Ayurveda finds you. You do not find Ayurveda.</p>
  <p>For years, I managed rheumatoid arthritis and amenorrhea 
     with NSAIDs and birth control. Over time, I felt increasingly 
     disconnected from my body, while my symptoms continued to evolve 
     into digestive issues, anxiety, deep burnout and fatigue.</p>
  <p>Then Ayurveda found me.</p>
  <p>Through Ayurveda and yoga, I began to listen to my body 
     differently—to notice its patterns, honour its needs, and 
     tend to its imbalances with greater awareness and care.</p>
  <p>Understanding nutrition, daily rhythms, movement, and the 
     senses gave me practical ways to reconnect with myself. Slowly, 
     these ancient sciences became less about managing symptoms and 
     more about remembering how to live in relationship with my own body.</p>
  <p>That experience is at the heart of this work.</p>
  <p>Witnessing clients and students come into greater alignment, learn 
    to trust their bodies, and remember who they are is the why behind 
    Remembering Ayurveda.</p>
  <p>Outside of teaching and consultations, I live and work on a small farm, 
     where I help run our food box program. Working with the land has deepened 
     my understanding of reciprocity, seasonality, nourishment, and community—and 
     these values naturally weave into the way I practice and teach.</p>
    <p>Whether we meet in the studio, in a consultation, at a workshop, or 
      simply through sharing a story, I would love to connect.</p>
  </div>

  </div>
  </section>

<section id="connect" className="section">
 <h2>Connect</h2>
  <h3>Instagram:</h3>
<a href="https://www.instagram.com/remembering.ayurveda" className="instagram" target="_blank" rel="noopener noreferrer">
  <FaInstagram size={28}/> @remembering.ayurveda
</a>
  <h3>Email:</h3>
  <a href="mailto: chloe.rememberingayurveda@gmail.com" className="email">
  <MdEmail size={28} /> chloe.rememberingayurveda@gmail.com
</a>
  <h2>On-Demand Meditations</h2>
  <InsightTimer />
  <h2>Workshops & Events</h2>
  <LinkTree />
  <h2>Work With Me</h2>
  <BookADiscoveryCall />
</section>  

</>

);
}

export default App;
